import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import breadcrumbsSelector from "selectors/breadcrumbs";
import classnames from "classnames";
import styles from "./NavBar.module.scss";

const NavBar: React.FC = () => {
    const breadcrumbs = useSelector(breadcrumbsSelector);

    return (
        <nav
            className={classnames(
                "nav bg-light navbar-light bg-light",
                styles.navBar
            )}
            aria-label="breadcrumb"
        >
            <ol
                style={{ margin: 0 }}
                className={classnames(
                    "breadcrumb bg-light",
                    styles.breadcrumbsList
                )}
            >
                {breadcrumbs.map((breadcrumb, idx) => {
                    const isCurrent = idx === breadcrumbs.length - 1;
                    if (isCurrent) {
                        return (
                            <li
                                key={breadcrumb.link}
                                className="breadcrumb-item active"
                                aria-current="page"
                            >
                                {breadcrumb.name}
                            </li>
                        );
                    } else {
                        return (
                            <li
                                className="breadcrumb-item"
                                key={breadcrumb.link}
                            >
                                <Link to={breadcrumb.link}>
                                    {breadcrumb.name}
                                </Link>
                            </li>
                        );
                    }
                })}
            </ol>
        </nav>
    );
};

export default NavBar;
